import { useState } from 'react';

import { TextField } from '@components/text-field';

import { useUpdateCompanyInfo } from 'api/companies/hooks';
import { ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';
import { Company } from 'types/companies';

import { SettingsModal } from './settings-modal';

type EditPrivacyPolicyUrlModalProps = ModalProps<{
  currentPrivacyPolicyUrl: Company['privacyPolicyUrl'];
}>;

export const EditPrivacyPolicyUrlModal = ({
  currentPrivacyPolicyUrl,
}: EditPrivacyPolicyUrlModalProps) => {
  const { t } = useStore();
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState(currentPrivacyPolicyUrl ?? '');
  const submit = useUpdateCompanyInfo({
    successMessage: t('company.settings.root.privacy.updateSuccess'),
    errorMessage: t('company.settings.root.privacy.updateError'),
  });

  return (
    <SettingsModal
      title={t('company.settings.root.privacy.title')}
      description={t('company.settings.root.privacy.description')}
      onSave={() => submit.mutate({ privacyPolicyUrl: privacyPolicyUrl || null })}
      saveDisabled={submit.isLoading}
    >
      <TextField
        label={t('company.settings.root.privacy.label')}
        placeholder={t('company.settings.root.privacy.placeholder')}
        value={privacyPolicyUrl}
        onChange={setPrivacyPolicyUrl}
      />
    </SettingsModal>
  );
};
